// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const FORMS_DEFAULT_REQUIRED_FIELD_ERROR = "Toto pole je povinn\u00e9.";
export const LAST_PERIOD_START = "Za\u010d\u00e1tek posledn\u00ed menstruace";
export const PREGNANCY_CALCULATOR_FORM_SUBMIT = "Vypo\u010d\u00edtej mi to";
export const PREGNANCY_CALCULATOR_FORM_TITLE = "Vypl\u0148 datum, kter\u00e9 zn\u00e1\u0161:";
export const SIGNUP_DUE_DATE = "Term\u00edn porodu";
